import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import PropTypes from 'prop-types';
import { isAuthenticationValid } from '../core/services/auth.service';

export const PrivateRoute = ({ children }) => {
  const { user } = useSelector((state) => state.auth);

  const isAuthenticated = user || isAuthenticationValid();

  if (isAuthenticated) {
    return children;
  }

  return <Navigate to="/signin" />;
};

// Add propTypes validation
PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

// export const RoleBasedRoute = ({ roles, children }) => {
//   const { user } = useSelector((state) => state.auth);

//   if (!user) {
//     return <Navigate to="/signin" />;
//   }

//   if (roles && !roles.some(role => user.roles?.includes(role))) {
//     return <Navigate to="/unauthorized" />; 
//   }

//   return children;
// };